import { useState } from 'react';
import Modal from '@mui/material/Modal'; 
import SoftBox from 'components/SoftBox';
import PropTypes from 'prop-types'; 

const ReportProblemModal = ({ open, onClose }) => {

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}
      >
        <SoftBox style={{
          width: '60%', 
          height: '80%',
          borderRadius: '12px', 
          
        }}>
          <iframe
            src="https://api.leadconnectorhq.com/widget/form/3aHKos69mmF6Mkv3pgaW"
            style={{ width: '100%', height: '100%', border: 'none', borderRadius: '12px' }}
            id="popup-3aHKos69mmF6Mkv3pgaW" 
            data-layout="{'id':'POPUP'}"
            data-trigger-type="alwaysShow"
            data-trigger-value=""
            data-activation-type="alwaysActivated"
            data-activation-value=""
            data-deactivation-type="neverDeactivate"
            data-deactivation-value=""
            data-form-name="Reporting problem"
            data-height="510"
            data-layout-iframe-id="popup-3aHKos69mmF6Mkv3pgaW"
            data-form-id="3aHKos69mmF6Mkv3pgaW"
            title="Reporting problem"
                >
          </iframe>
          <script src="https://link.msgsndr.com/js/form_embed.js"></script>
        </SoftBox>
      </Modal>
    </>
  );
};

ReportProblemModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ReportProblemModal;
